import { render, staticRenderFns } from "./FormulariosNovoBem.vue?vue&type=template&id=078036b7"
import script from "./FormulariosNovoBem.vue?vue&type=script&lang=js"
export * from "./FormulariosNovoBem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports